import { BASE_END_POINT } from "../../parametros";
import { RespostaSolicitacaoCompraDTO } from "../dtos/RespostaSolicitacaoCompraDTO";
import { alertService } from "./alertService";
import i18n from '../../i18n/index';

async function checkoutCompra(
    respostaSolicitacaoCompra: RespostaSolicitacaoCompraDTO
): Promise<void> {

    try {
        const url = `${BASE_END_POINT}/api-v1/pagamentos/${respostaSolicitacaoCompra.Id}/checkout`;
        window.location.href = url;
    } catch (ex) {
        alertService.toast(
            i18n.t("CHECKOUT_REDIRECT_ERROR"),
            'error'
        );
        console.error("Erro ao redirecionar para o checkout:", ex);
        throw ex;
    }
}

export { checkoutCompra };
